import { ConfirmationButton } from '@/components/misc/ConfirmationButton';
import { Trash2 } from 'lucide-react';
import * as React from 'react';
import { useScheduleUsers } from '@/hooks/swr/use-schedule-users';

export const DeleteScheduleUserPopover = ({
  id,
  scheduleId,
}: {
  id: string;
  scheduleId: string;
}) => {
  const { remove } = useScheduleUsers({ scheduleId });

  return (
    <ConfirmationButton
      trigger={
        <button className="rounded-full p-2 hover:bg-muted" onClick={(e) => e.stopPropagation()}>
          <Trash2 className="h-4 w-4 text-muted-foreground hover:text-destructive" />
        </button>
      }
      onConfirm={async () => await remove(id)}
    />
  );
};
